<div class="w-100 text-center py-2">
  <button mat-button
    (click)="add.emit()">
    <mat-icon color="primary">add</mat-icon> {{label | translate}}
  </button>
</div>